<template>
  <div class="row filter-row">
    <!-- <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocused }">
        <input type="text" class="form-control floating" v-model="employeeID" @focus="isFocused = true"
          @blur="isFocused = employeeID !== ''" />
        <label class="focus-label">Employee ID</label>
      </div>
    </div> -->
    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="selectedEmployee" :items="employeeOptions" variant="outlined" density="comfortable"
        item-title="text" item-value="text" clearable label="Employee Name" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="selectedLocation" :items="locationOptions" variant="outlined" density="comfortable"
        item-title="text" item-value="id" clearable label="Location" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="company_role_id" :items="companyRole" variant="outlined" density="comfortable"
        item-title="text" item-value="id" clearable label="Role" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="status-segmented-control">
        <div 
          class="slider-bg" 
          :class="{ 'slide-right': currentStatus === 'inactive' }"
        ></div>
        <button 
          type="button" 
          class="status-tab-btn" 
          :class="{ active: currentStatus === 'active' }"
          @click="setStatus('active')"
        >
          <i class="fa-solid fa-circle-check me-1"></i> Active
        </button>
        <button 
          type="button" 
          class="status-tab-btn" 
          :class="{ active: currentStatus === 'inactive' }"
          @click="setStatus('inactive')"
        >
          <i class="fa-solid fa-circle-xmark me-1"></i> Inactive
        </button>
      </div>
    </div>
    <!-- <div class="col-sm-6 col-md-3">
      <div class="d-flex justify-content-between"> <a href="javascript:;" class="btn btn-success w-100 me-2"
          @click="onSearchClick"> Search </a>
        <a href="javascript:;" class="btn btn-secondary w-100" @click="onClearClick"> clear </a>
      </div>

    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../config";
export default {
  props: {
    initialStatus: {
      type: String,
      default: "active"
    }
  },
  data() {
    return {
      selectedEmployee: null,
      selectedLocation: null,
      company_role_id: null,
      companyRole: [],
      employeeOptions: [],
      locationOptions: [],
      currentStatus: this.initialStatus
    };
  },
  watch: {
    initialStatus(newVal) {
      if (this.currentStatus !== newVal) {
        this.currentStatus = newVal;
        this.selectedEmployee = null;
        this.getEmployees();
      }
    }
  },
  mounted() {
    this.getCompanyRoles();
    this.getEmployees();
    this.getLocations();
  },
  methods: {
    setStatus(status) {
      if (this.currentStatus !== status) {
        this.currentStatus = status;
        this.selectedEmployee = null;
        this.getEmployees();
        this.onSearchClick();
      }
    },
    onSearchClick() {
      this.$emit("searchClicked", {
        employee_name: this.selectedEmployee || "",
        location_id: this.selectedLocation,
        company_role_id: this.company_role_id,
        status: this.currentStatus
      });
    },
    onClearClick() {
      this.selectedEmployee = null;
      this.selectedLocation = null;
      this.company_role_id = null;
      this.currentStatus = "active";
      this.getEmployees();
      this.$emit("searchClicked", {
        employee_name: "",
        location_id: null,
        company_role_id: null,
        status: "active"
      });
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyRole = response.data.data.map(element => ({
              id: element.id,
              text: element.name
            }));
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getEmployees() {
      const endpoint = this.currentStatus === 'inactive'
        ? `${VUE_APP_API_BASE_URL}/user/deactivated-user-list`
        : `${VUE_APP_API_BASE_URL}/user/user-list`;

      await axios.get(endpoint)
        .then((response) => {
          if (response.data.status) {
            const seen = new Set();
            const options = [];
            for (const element of response.data.data) {
              const fullName = `${element.first_name} ${element.last_name}`.trim();
              if (!seen.has(fullName)) {
                seen.add(fullName);
                options.push({
                  id: element.id,
                  text: fullName
                });
              }
            }
            this.employeeOptions = options;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getLocations() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationOptions = response.data.data.map(element => ({
              id: element.id,
              text: element.name
            }));
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.status-segmented-control {
  position: relative;
  display: flex;
  background-color: #f1f3f5;
  border-radius: 6px;
  padding: 4px;
  height: 48px;
  align-items: center;
  border: 1px solid #caced1;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03);
}

.slider-bg {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.02);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1;
}

.slider-bg.slide-right {
  left: calc(50%);
}

.status-tab-btn {
  position: relative;
  flex: 1;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 13.5px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: color 0.25s ease;
  outline: none;
}

.status-tab-btn:hover:not(.active) {
  color: #334155;
}

.status-tab-btn.active {
  color: #25628f;
  font-weight: 600;
}

.status-tab-btn i {
  font-size: 14px;
  transition: transform 0.25s ease;
}

.status-tab-btn.active i {
  transform: scale(1.1);
}

.status-tab-btn.active .fa-circle-check {
  color: #10b981;
}

.status-tab-btn.active .fa-circle-xmark {
  color: #ef4444;
}

/* Dark mode styling */
[data-layout-mode=dark] .status-segmented-control {
  background-color: #2d3d45;
  border-color: #40525c;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

[data-layout-mode=dark] .slider-bg {
  background-color: #34444c;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

[data-layout-mode=dark] .status-tab-btn {
  color: #a6b0cf;
}

[data-layout-mode=dark] .status-tab-btn:hover:not(.active) {
  color: #eff2f7;
}

[data-layout-mode=dark] .status-tab-btn.active {
  color: #ffffff;
}
</style>
